import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  gap: 24px;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;

  @media (max-width: 1200px) {
    flex-direction: column;
    gap: 20px;
  }

  @media (max-width: 768px) {
    /* padding: 10px; */
    gap: 15px;
  }

  .sidebar-overlay {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    backdrop-filter: blur(10px);
    z-index: 998;
    border-radius: 25px;
    @media (max-width: 1200px) {
      display: block;
    }
  }
`;

export const VideoSection = styled.div`
  flex: 1;
  background: var(--surface);
  overflow: hidden;
  box-shadow: var(--shadow-soft);
  height: fit-content;
  border-radius: 25px;

  .lesson-description {
    padding: 24px;
    border-top: 1px solid var(--background);

    h3 {
      font-size: 18px;
      font-weight: 600;
      color: var(--text-primary);
      margin-bottom: 12px;
    }

    p {
      color: var(--text-secondary);
      line-height: 1.6;
      font-size: 14px;
    }

    @media (max-width: 768px) {
      padding: 16px;

      h3 {
        font-size: 16px;
        margin-bottom: 8px;
      }
    }
  }
`;

export const VideoHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid var(--background);
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .header-left {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    flex: 1;
  }

  .sidebar-toggle {
    display: none;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: var(--primary);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: var(--accent);
    }

    @media (max-width: 1200px) {
      display: flex;
    }

    @media (max-width: 768px) {
      padding: 6px 12px;
      font-size: 12px;
    }
  }

  @media (max-width: 768px) {
    padding: 16px;
    flex-direction: column;
    gap: 12px;

    .header-left {
      align-items: flex-start;
      gap: 12px;
    }

    .sidebar-toggle {
      align-self: flex-end;
    }
  }
`;

export const LessonTitle = styled.h1`
  font-size: ${(props) => (props.$small ? "18px" : "28px")};
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 12px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: ${(props) => (props.$small ? "16px" : "20px")};

    margin-bottom: 8px;
  }
`;

export const LessonMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  color: var(--text-secondary);
  font-size: 14px;

  span {
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
      color: var(--primary);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    font-size: 12px;
  }
`;

export const VideoPlayerContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background: #000;
`;

export const PlayerLoadingContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;

  p {
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    margin: 0;
  }
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: var(--surface);
  border: 2px solid var(--background);
  border-radius: 50%;
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  gap: 6px;

  &:hover {
    background: var(--primary);
    color: white;
    border-color: var(--primary);
    transform: translateX(-2px);
  }

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
`;

export const SidebarContainerMobile = styled.div`
  width: 380px;
  background: var(--surface);
  border-radius: 16px;
  box-shadow: var(--shadow-soft);
  height: fit-content;
  max-height: calc(100vh - 40px);
  overflow: auto;
  display: none;
  flex-direction: column;

  @media (max-width: 1200px) {
    display: flex;
  }
`;
export const SidebarContainer = styled.div`
  width: 380px;
  background: var(--surface);
  border-radius: 16px;
  box-shadow: var(--shadow-soft);
  height: fit-content;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media (max-width: 1200px) {
    display: none; /* Hidden on mobile - use GlobalVideoSidebar instead */
  }
`;

export const LessonsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const LessonsHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid var(--background);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;

  h3 {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
    margin: 0;
  }

  button {
    background: none;
    border: none;
    font-size: 24px;
    color: var(--text-secondary);
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: all 0.3s ease;

    &:hover {
      background: var(--background);
      color: var(--accent);
    }

    @media (min-width: 1201px) {
      display: none;
    }
  }

  @media (max-width: 768px) {
    padding: 16px;

    h3 {
      font-size: 16px;
    }
  }
`;

export const LessonsList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 768px) {
    padding: 12px 16px 16px;
    gap: 10px;
  }
`;

export const LessonItem = styled.div`
  border: 2px solid
    ${(props) =>
      props.$active
        ? "var(--primary)"
        : props.$unlocked
          ? "var(--background)"
          : "var(--surface-disabled)"};
  border-radius: 12px;
  overflow: hidden;
  cursor: ${(props) => (props.$unlocked ? "pointer" : "not-allowed")};
  transition: all 0.3s ease;
  opacity: ${(props) => (props.$unlocked ? 1 : 0.6)};

  background: ${(props) => {
    if (props.$active) return "var(--primary-light-bg)";
    if (props.$completed) return "var(--success-light-bg)";
    return "transparent";
  }};

  &:hover {
    box-shadow: ${(props) =>
      props.$unlocked && !props.$active
        ? "0 4px 12px rgba(124, 14, 51, 0.1)"
        : "none"};
  }

  &:focus-visible {
    outline: 2px solid var(--primary);
    outline-offset: 2px;
  }

  display: flex;
  padding: 16px;
  gap: 12px;
  align-items: flex-start;

  @media (max-width: 768px) {
    padding: 12px;
    gap: 10px;
    /* flex-direction: column; */
    /* align-items: center; */
  }
`;

export const LessonIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: white;
  flex-shrink: 0;

  background: ${(props) => {
    if (!props.$unlocked) return "var(--text-muted)";
    if (props.$completed) return "var(--success)";
    return "var(--primary)";
  }};

  @media (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
`;

export const LessonInfo = styled.div`
  flex: 1;
  min-width: 0;
  @media (max-width: 768px) {
    /* text-align: center; */
  }
`;

export const SidebarLessonTitle = styled.div`
  font-weight: 600;
  color: ${(props) =>
    props.$active ? "var(--primary)" : "var(--text-primary)"};
  font-size: 15px;
  margin-bottom: 4px;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const LessonDuration = styled.div`
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 6px;
    text-align: left;
  }
`;

export const LessonProgress = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 12px;
    color: var(--text-secondary);
    min-width: 35px;
    text-align: right;
  }
`;

export const ProgressBar = styled.div`
  flex: 1;
  height: 4px;
  background: var(--background);
  border-radius: 2px;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: var(--primary);
  border-radius: 2px;
  transition: width 0.3s ease;
  width: ${(props) => props.width}%;
`;

export const CertificateSection = styled.div`
  padding: 24px;
  border-top: 1px solid var(--background);
  text-align: center;
  flex-shrink: 0;

  h4 {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 8px;
  }

  p {
    font-size: 14px;
    color: var(--text-secondary);
    margin-bottom: 16px;
    line-height: 1.4;
  }

  @media (max-width: 768px) {
    padding: 16px;

    h4 {
      font-size: 14px;
      margin-bottom: 6px;
    }

    p {
      font-size: 12px;
      margin-bottom: 12px;
    }
  }
`;

export const CertificateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: var(--accent);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: var(--accent-dark);
    transform: translateY(-2px);
  }

  svg {
    font-size: 14px;
  }

  @media (max-width: 768px) {
    padding: 10px 14px;
    font-size: 12px;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  gap: 12px;
  min-height: 500px;

  .spinner {
    width: 40px;
    height: 40px;
    border: 4px solid var(--background);
    border-top: 4px solid var(--primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
  }

  p {
    color: var(--text-secondary);
    font-size: 16px;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    .spinner {
      width: 32px;
      height: 32px;
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
    }
  }
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 12px;
  gap: 12px;
`;
export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;

  h2 {
    font-size: 24px;
    font-weight: 600;
    color: var(--text-primary);
  }

  p {
    color: var(--text-secondary);
    font-size: 16px;

    line-height: 1.5;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    h2 {
      font-size: 20px;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
`;

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;

  h2 {
    font-size: 24px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 12px;
  }

  p {
    color: var(--text-secondary);
    font-size: 16px;
    margin-bottom: 24px;
    line-height: 1.5;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;

    h2 {
      font-size: 20px;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
`;

// export const CertificateSection = styled.div`
//   text-align: center;
// `;

export const CertificateIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`;

export const CertificateIconCircle = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: white;
  box-shadow: 0 4px 12px rgba(124, 14, 51, 0.3);
`;

export const CertificateTitle = styled.h4`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  color: var(--text-primary);
  margin-bottom: 12px;

  svg {
    color: var(--accent);
  }
`;

export const CertificateDescription = styled.p`
  color: var(--text-secondary);
  font-size: 14px;
  margin-bottom: 16px;
  line-height: 1.4;
`;

export const CertificateBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 12px 16px;
  background: ${(props) =>
    props.disabled ? "var(--surface-disabled)" : "var(--accent)"};
  color: ${(props) => (props.disabled ? "var(--text-muted)" : "white")};
  border: none;
  border-radius: 8px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: var(--accent-dark);
    transform: translateY(-2px);
  }

  svg {
    font-size: 14px;
  }

  svg {
    animation: ${(props) =>
      props.$status ? "hourglassFlip 1.8s ease-in-out infinite" : "none"};
    transform-style: preserve-3d;
  }

  @keyframes hourglassFlip {
    0% {
      transform: rotateX(0deg);
    }
    45% {
      transform: rotateX(180deg);
    }
    55% {
      transform: rotateX(180deg);
    }
    60% {
      transform: rotateX(180deg);
    }
    100% {
      transform: rotateX(360deg);
    }
  }
`;

export const PdfScriptsSection = styled.div`
  padding: 20px;
  padding-top: 0;
  background: var(--surface);
  border-radius: 12px;
  /* border: 1px solid var(--accent-light); */
`;

export const PdfScriptsTitle = styled.h3`
  margin: 0 0 15px 0;
  color: var(--text);
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const PdfScriptsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PdfScriptButton = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  background: var(--background);
  border: 1px solid var(--accent-light);
  border-radius: 8px;
  color: var(--text);
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    background: var(--accent-light);
    border-color: var(--accent);
  }
`;

export const PdfScriptInfo = styled.div`
  text-align: left;
  flex: 1;
`;

export const PdfScriptTitle = styled.div`
  font-weight: 600;
`;

export const PdfScriptDescription = styled.div`
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
`;

export const PdfScriptDownloadIcon = styled.div`
  margin-left: auto;
`;
